const downloadButtons = document.querySelectorAll(".add-to-calendar");

if (!!downloadButtons){
  downloadButtons.forEach((button) => {
    button.addEventListener('click', () => {

      const title = button.dataset.downloadTitle; // "3"
      const data = button.dataset.downloadData; // "12314"

      download(title+".ics", data);

    });
  });
}

function download(filename, text) {
  const element = document.createElement('a');
  element.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}